import React, { PropsWithChildren, ReactNode } from 'react';
import { styled } from '@mui/material';

import { RootState, useAppSelector } from '@/state/store';
import { Header, Messages, ModalDialog, Button } from '@/components';
import { hideApplicationBlocked } from '@/actions/common';
import { createSelector } from '@reduxjs/toolkit';
import t from '@/utils/translate';

export type LayoutProps = {
  logo?: ReactNode,
  ['header-left-side']?: ReactNode,
  ['header-center']?: ReactNode,
  ['header-right-side']?: ReactNode,
} & PropsWithChildren;

const Main = styled('main')(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(15),
  bottom: 0,
  backgroundColor: '#ffffff',
  overflow: 'auto',
  zIndex: 1101,
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  '&>*': {
    flexShrink: 0,
  }
}));

const CustomHeader = styled(Header)`
  border-bottom: solid 1px #DFE1E6;
  z-index: 1100;
  width: 100%;
`;

export default ({ children, ...props }: LayoutProps) => {
  const { applicationBlocked } = useAppSelector(
    createSelector(
      [ (state: RootState) => state.common.applicationBlocked ],
      (applicationBlocked) => ({ applicationBlocked })
    )
  );

  return (
    <>
      <CustomHeader
        logo={props.logo}
        left-children={ props['header-left-side'] }
        right-children={ props['header-right-side'] }
      >
        { props['header-center'] }
      </CustomHeader>

      <Main style={{ width: '100%' }}>
        {children}
        <footer>
          <Messages />

          <ModalDialog
            title=''
            open={applicationBlocked}
            onClose={hideApplicationBlocked}
            maxHeight="90%"
            maxWidth="90%"
          >
            <p>
              {t('common.message.actionFailedNeedReload', true)}
            </p>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => location.reload()}
            >
              {t('action.reload')}
            </Button>
          </ModalDialog>
        </footer>
      </Main>
    </>
  );
};